module.exports = __webpack_public_path__ + "img/LT304870069.85e2ab53.svg";